// import VueCookies from "vue-cookies";


const site = {
  activeSite: "/",
  servername: "1",
  serverip: "1",
  serverport: "1",

};
const state = {
  servername: "",
  serverip: "",
  serverport: "",

};

const mutations = {
  setActiveSite(site, activeSite) {
    site.activeSite = activeSite;
    //   console.log("neuer Wert " + site.activeSite);
  },
};


const getters = {
  getActiveSite: (site) => {
    // console.log("gebe zurück: " + site.activeSite);
    return site.activeSite;
  },

};

const mainModule = {
  site,
  state,
  mutations,
  getters,
};

export default mainModule;
